import React, { useState } from 'react';
import MarketingSignup from './MarketingSignup';
import Button from './ui/Button';
import SectionHeading from './ui/SectionHeading';
import { SITE, STORE_HOURS } from '../constants/site';

function ContactSection() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const apiUrl = `${process.env.REACT_APP_APIUrl}/ContactUsForm`;
      const clientId = process.env.REACT_APP_ClientId;

      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ClientId: clientId,
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setFormData({ name: '', email: '', message: '' });
        alert('Message sent successfully');
      } else {
        console.error('Form submission failed', response.statusText);
      }
    } catch (error) {
      console.error('Error occurred during form submission:', error);
    }
  };

  const inputClass =
    'mt-2 block w-full rounded-xl border border-slate-200 px-4 py-3 text-slate-900 shadow-sm transition-colors placeholder:text-slate-400 focus:border-optical-400 focus:outline-none focus:ring-2 focus:ring-optical-500/30';

  return (
    <section className="bg-white py-16 md:py-24" id="contact-us" aria-labelledby="contact-heading">
      <div className="mx-auto max-w-7xl px-6">
        <SectionHeading
          id="contact-heading"
          eyebrow="We’re here to help"
          title="Contact us"
          subtitle="Questions about frames, exams, or your prescription? Reach out online or visit us on Willis Ave."
        />

        <div className="grid gap-10 lg:grid-cols-2 lg:gap-14">
          <div className="rounded-2xl border border-slate-100 bg-white p-8 shadow-card md:p-10">
            <h3 className="font-display text-xl font-semibold text-slate-900">Send a message</h3>
            <p className="mt-2 text-slate-600">We’ll respond as soon as we can during business hours.</p>

            <form onSubmit={handleSubmit} className="mt-8 space-y-6">
              <div>
                <label htmlFor="name" className="text-sm font-medium text-slate-800">
                  Name
                </label>
                <input
                  type="text"
                  name="name"
                  id="name"
                  value={formData.name}
                  onChange={handleChange}
                  className={inputClass}
                  autoComplete="name"
                  required
                />
              </div>
              <div>
                <label htmlFor="email" className="text-sm font-medium text-slate-800">
                  Email
                </label>
                <input
                  type="email"
                  name="email"
                  id="email"
                  value={formData.email}
                  onChange={handleChange}
                  className={inputClass}
                  autoComplete="email"
                  required
                />
              </div>
              <div>
                <label htmlFor="message" className="text-sm font-medium text-slate-800">
                  Message
                </label>
                <textarea
                  name="message"
                  id="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows={5}
                  className={inputClass}
                  required
                />
              </div>
              <Button variant="primary" type="submit" className="w-full sm:w-auto">
                Send message
              </Button>
            </form>
          </div>

          <div className="flex flex-col gap-10">
            <div className="rounded-2xl border border-slate-100 bg-slate-50/80 p-8 shadow-card md:p-10">
              <h3 className="font-display text-xl font-semibold text-slate-900">{SITE.businessName}</h3>
              <ul className="mt-6 space-y-4 text-slate-700">
                <li>
                  <span className="block text-xs font-semibold uppercase tracking-wide text-optical-600">Phone</span>
                  <a
                    href={`tel:${SITE.phone.tel}`}
                    className="mt-1 inline-block text-lg font-medium text-slate-900 underline decoration-optical-300 underline-offset-4 hover:text-optical-700"
                  >
                    {SITE.phone.display}
                  </a>
                </li>
                <li>
                  <span className="block text-xs font-semibold uppercase tracking-wide text-optical-600">Email</span>
                  <a
                    href={`mailto:${SITE.email}`}
                    className="mt-1 inline-block break-all text-lg font-medium text-slate-900 underline decoration-optical-300 underline-offset-4 hover:text-optical-700"
                  >
                    {SITE.email}
                  </a>
                </li>
                <li>
                  <span className="block text-xs font-semibold uppercase tracking-wide text-optical-600">Address</span>
                  <address className="mt-1 not-italic text-lg leading-relaxed text-slate-800">
                    {SITE.address.street}
                    <br />
                    {SITE.address.cityLine}
                  </address>
                </li>
              </ul>

              <div className="mt-8 flex flex-wrap gap-3">
                <Button variant="primary" href={SITE.directionsUrl}>
                  Open in Google Maps
                </Button>
                <Button variant="secondary" href="#store-info">
                  Store hours
                </Button>
              </div>
            </div>

            <div className="rounded-2xl border border-slate-100 bg-white p-8 shadow-card md:p-10">
              <h3 className="font-display text-lg font-semibold text-slate-900">Quick hours</h3>
              <ul className="mt-4 space-y-2 text-sm text-slate-600">
                {STORE_HOURS.map(({ day, hours, closed }) => (
                  <li key={day} className="flex justify-between gap-4 border-b border-slate-100 py-2 last:border-0">
                    <span className="font-medium text-slate-800">{day}</span>
                    <span>{closed ? <span className="font-medium text-optical-700">Closed</span> : hours}</span>
                  </li>
                ))}
              </ul>
              <p className="mt-4 text-sm text-slate-500">
                Holiday hours may vary — call ahead if you’re unsure.
              </p>
            </div>

            <MarketingSignup />
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactSection;
